import { FolderSymlinkIcon } from '~components/icons/FolderSymlinkIcon';
import { SpinnerIcon } from '~components/icons/SpinnerIcon';
import { Button } from '~modules/media-library/view/Button';

type MyFilesDetailProps = {
  documentName: string;
  isLoading?: boolean;
  onExport: () => void;
  error?: boolean;
};

export function MyFilesDetail({ error, isLoading, documentName, onExport }: MyFilesDetailProps) {
  return (
    <div className="flex justify-between items-center h-8 font-sans text-black ">
      {!error ? (
        <>
          <div className="text-base pr-2">{documentName}</div>
          {!isLoading ? (
            <Button variant="icon" onClick={onExport}>
              <FolderSymlinkIcon />
            </Button>
          ) : (
            <SpinnerIcon className="animate-spin w-4 h-4" />
          )}
        </>
      ) : (
        <div className="text-red">Unknown error</div>
      )}
    </div>
  );
}
